var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarredDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.883,
    height: 17.138,
    viewBox: "0 0 17.883 17.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M17.836,6.972a.949.949,0,0,0-.817-.653L11.856,5.85,9.816,1.074a.951.951,0,0,0-1.749,0L6.027,5.85.864,6.319a.952.952,0,0,0-.54,1.663l3.9,3.422L3.075,16.471A.95.95,0,0,0,4.49,17.5l4.452-2.662L13.392,17.5a.951.951,0,0,0,1.415-1.028L13.657,11.4l3.9-3.422a.952.952,0,0,0,.277-1.01ZM9.027,14.786",
    transform: "translate(0 -0.496)",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarredDark);
export default __webpack_public_path__ + "static/media/starred-dark.7a84fa5c48ea4bb9e07ac4837ae0a5bf.svg";
export { ForwardRef as ReactComponent };